module.exports = __webpack_public_path__ + "img/icon2.9902f62e.png";